export const env = {
  maintenance: import.meta.env.VITE_MAINTENANCE === 'true',
  appStage: import.meta.env.VITE_APP_STAGE || 'local',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:3000',
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN || '',
  cognitoDjClientId: import.meta.env.VITE_COGNITO_DJ_CLIENT_ID || '',
  cognitoGuestClientId: import.meta.env.VITE_COGNITO_GUEST_CLIENT_ID || '',
  cognitoRedirectUri: import.meta.env.VITE_COGNITO_REDIRECT_URI || '',
  cognitoGuestRedirectUri: import.meta.env.VITE_COGNITO_GUEST_REDIRECT_URI || '',
  cognitoLogoutUri: import.meta.env.VITE_COGNITO_LOGOUT_URI || '',
  googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
};
